export default {
  SHOW: '@WS_EDITOR/MAIN_MENU/SHOW',
  HIDE: '@WS_EDITOR/MAIN_MENU/HIDE',
};
